module.exports = __webpack_public_path__ + "s6.no1.8b62c310.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s6.no1.jpg
// module id = //07
// module chunks = 0